// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*
  Headers
 */
/*
  Base Sizing
 */
/*
  Colors
 */
/*
  Border Radii Sizes
 */
/*
  Shadows
 */
/*
  Global Styles
 */
html {
  font-size: 10px;
}

/**
 * COODE Header Colors
 */
.elements-center {
  text-align: -webkit-center;
}
.iybr-form-confirmation-p-column {
  margin-left: 30%;
  margin-right: 30%;
}
.iybr-form-confirmation-icon {
  color: #0476D9;
  margin-top: 2.56rem;
}
.confirm-message {
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Oxygen, Ubuntu, Cantarell, "Open Sans", "Helvetica Neue", sans-serif;
  font-weight: 500;
}
.confirm-unique-id {
  font-weight: 700;
  display: inline-block;
}
.iybr-overview-btn {
  margin-top: 1%;
  margin-bottom: 5%;
}
.unique-id {
  color: #0476D9;
  font-weight: bold;
}`, ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
